import client from './client'

export interface LoginRequest {
  username: string
  password: string
}

export interface RegisterRequest {
  username: string
  password: string
  display_name: string
}

export interface UserResponse {
  id: string
  username: string
  display_name: string
  created_at: string
}

export interface TokenResponse {
  access_token: string
  refresh_token: string
  token_type: string
  user: UserResponse
}

export const authApi = {
  register(data: RegisterRequest) {
    return client.post<TokenResponse>('/auth/register', data).then((r) => r.data)
  },

  login(data: LoginRequest) {
    return client.post<TokenResponse>('/auth/login', data).then((r) => r.data)
  },

  refresh(refreshToken: string) {
    return client
      .post<TokenResponse>('/auth/refresh', { refresh_token: refreshToken })
      .then((r) => r.data)
  },

  profile() {
    return client.get<UserResponse>('/auth/me').then((r) => r.data)
  },

  updateProfile(data: { display_name?: string }) {
    return client.patch<UserResponse>('/auth/me', data).then((r) => r.data)
  },
}
